import type { ClubSeasonUserRank } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { Translation } from '@ps/web-shared-components';
import React, { memo } from 'react';

import { PKR_USERS_IN_LEADER_BOARD_NUMBER } from '../../../../../constants/constants';
import { firstLetter } from '../../../../../utils/firstLetter';
import { getAvatarColor } from '../../../../../utils/getAvatarColor';

import {
  TXTWCL_Leaderboard_will_be_displayed__ELL,
  TXTWCL_Leaders_of_the_Season
} from './LeaderBoard.messages.json';
import styles from './LeaderBoard.scss';
import BgImageLeftIcon from './assets/bg-image-left.svg';
import BgImageRightIcon from './assets/bg-image-right.svg';
import EmptyLeadersIcon from './assets/empty-leaders-icon.svg';

interface LeaderBoardProps {
  ranks: ClubSeasonUserRank[];
}

const LeaderBoard: React.FC<LeaderBoardProps> = ({ ranks }) => (
  <div className={styles.leaderboardContainer} data-testid="leaderboard-container">
    <div className={styles.leadersTitle}>
      <Translation tagName="p" {...TXTWCL_Leaders_of_the_Season} />
    </div>
    <div className={styles.leadersContainer}>
      {ranks.length === PKR_USERS_IN_LEADER_BOARD_NUMBER ? (
        <div className={styles.leadersRow}>
          {ranks.map(({ rank, userId, pointsTotal }, i) => (
            <div key={userId} className={styles.leadersItem}>
              <div
                className={styles.leadersAvatar}
                style={{ backgroundColor: getAvatarColor(userId) }}
                data-testid={`leaderboard-user-avatar-${userId}`}
              >
                <span data-testid={`leaderboard-user-avatar-content-${i}`}>
                  {userId && firstLetter(userId)}
                </span>
                <div className={styles.leadersRank} data-testid={`leaderboard-user-rank-${i}`}>
                  {rank}
                </div>
              </div>
              <div className={styles.leadersUsername} data-testid={`leaderboard-user-name-${i}`}>
                {userId}
              </div>
              <div className={styles.leadersPoints} data-testid={`leaderboard-user-points-${i}`}>
                {pointsTotal && parseFloat((pointsTotal / 1000).toFixed(2))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <>
          <EmptyLeadersIcon />
          <div className={styles.leaderMessageContainer}>
            <Translation tagName="p" {...TXTWCL_Leaderboard_will_be_displayed__ELL} />
          </div>
        </>
      )}
    </div>

    <BgImageLeftIcon className={styles.bgImageLeft} />
    <BgImageRightIcon
      className={styles.bgImageRight}
      style={{
        color:
          ranks.length === PKR_USERS_IN_LEADER_BOARD_NUMBER
            ? getAvatarColor(ranks[0]?.userId)
            : null
      }}
    />
  </div>
);
export default memo(LeaderBoard);
